import React, { ReactNode, useContext, useState } from "react"
import { Col, Row, Button, Flex, Upload, Spin, Divider, Tooltip, Checkbox } from "antd"

import { ContextInscricao } from "../InscricaoDaViagem"
import { useObterMinutaInscricao } from "@/Services/Domain/Viagem/InscricaoService";

export const Minuta: React.FC<{
    onSucesso?: () => void;
    onCancelar?: () => void;
    textoSalvar?: ReactNode;
    textoCancelar?: ReactNode;
}> = (props) => {
    const textoSalvar = props.textoSalvar ?? "Salvar";
    const textoCancelar = props.textoCancelar ?? "Cancelar";

    const { inscricao } = useContext(ContextInscricao);

    const [concordou, setConcordou] = useState<boolean>(false);

    const minutaQuery = useObterMinutaInscricao({
        codigo: inscricao?.codigo ?? 0,
        enabled: (inscricao?.codigo ?? 0) > 0,
        placeholderData: undefined,
    });

    const estaProcurandoDocumentos = minutaQuery.isFetching;

    if (estaProcurandoDocumentos)
        return (
            <Flex justify="center" align="middle">
                <Spin tip={"Carregando..."} size="large"></Spin>
            </Flex>
        );

    return (
        <>
            {minutaQuery.data?.data && (
                <React.Fragment>
                    <Row justify="center" align="middle" gutter={16}>
                        <Col xs={24} sm={22} md={20} lg={22} xl={20} xxl={18}>
                            <Upload
                                maxCount={1}
                                multiple={false}
                                listType="picture"
                                fileList={[
                                    {
                                        uid: "1",
                                        name: "Contrato de viagem",
                                        status: "done",
                                        url: URL.createObjectURL(minutaQuery.data.data),
                                        type: minutaQuery.data.data.type,
                                    },
                                ]}
                                showUploadList={{ previewIcon: true, showRemoveIcon: false, showDownloadIcon: true }}
                            ></Upload>
                        </Col>
                    </Row>

                    <Divider />

                    <Checkbox checked={concordou} onClick={() => setConcordou(!concordou)}>
                        Concordo com os termos de viagens propostos acima.
                    </Checkbox>

                    <Divider />

                    <Flex justify="start" gap={8}>
                        <Button type="primary" danger htmlType="button" onClick={() => props.onCancelar?.()}>
                            {textoCancelar}
                        </Button>

                        <Tooltip title={!concordou ? "Você possui pendências em sua documentação" : undefined}>
                            <Button
                                type="primary"
                                htmlType="button"
                                disabled={estaProcurandoDocumentos || !concordou}
                                onClick={() => !estaProcurandoDocumentos && concordou && props.onSucesso?.()}
                            >
                                {textoSalvar}
                            </Button>
                        </Tooltip>
                    </Flex>
                </React.Fragment>
            )}
        </>
    );
};
